export default __webpack_public_path__ + "static/media/expressjs.cc5d8b04.png";